import * as hooks from './hooks'
import vuexModule from './vuex/vuex-module'

//index.js только для поддключения вниешних сервисов
export default {hooks,vuexModule,vuexPlugin:undefined}